import { render, staticRenderFns } from "./MemoryPanel.vue?vue&type=template&id=445c9738&lang=pug"
import script from "./MemoryPanel.vue?vue&type=script&lang=js"
export * from "./MemoryPanel.vue?vue&type=script&lang=js"
import style0 from "./MemoryPanel.vue?vue&type=style&index=0&id=445c9738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports